import { connect } from 'react-redux';

// Components
import Price from './Price';

// Selectors
import { getPriceVisibility } from 'store/reducers/dealerSettings/selectors';
import { getCountryCode } from 'store/reducers/dealerLocale/selectors';

const mapStateToProps = (state, { type, value, showZero, ...ownProps }) => ({
  ...ownProps,
  value,
  hidden: !(getPriceVisibility(state)(type) && (value > 0 || showZero)),
  countryCode: getCountryCode(state)
});

export default connect(mapStateToProps)(Price);



// WEBPACK FOOTER //
// ./src/components/atoms/Price/PriceContainer.js